import React from "react";
import CertificateRouter from './Certificate/Router';
export { getFields, getReplyFields } from './Certificate/Router';

export default function CertificatePmRouter(props){
    return <CertificateRouter {...props} mode='PM' />;
}